import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        alignSelf: 'stretch',
        marginBottom: 14
    },
    input: {
        alignSelf: 'stretch',
        backgroundColor: '#FFFFFF',
        fontSize: 21,
        color: '#333333',
        height: 55,
        borderRadius: 3,
        paddingHorizontal: 12
    },
    switchContainer: {
        position: 'absolute',
        right: 20,
        height: '100%',
        width: 30,
        alignItems: 'center',
        justifyContent: 'center'
    },
    switch: {
        width: 30,
        height: 30,
        alignSelf: 'center',
        color: Theme.primaryActiveColor
    },
    info: {
        marginTop: 20,
        width: 25,
        height: 25,
        alignSelf: 'center',
        color: Theme.primaryActiveColor
    }
};

export default StyleSheet.create(baseStyles);
